import { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
export const CustomDropdown = ({ label, options, value, onChange, isLots, isGreeks }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div ref={dropdownRef} className="relative text-[10px]">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center justify-between border  rounded px-2 py-1  ${isLots ? 'bg-p400 border-n200 min-w-[50px]' : 'bg-n100 border-n500 min-w-[60px]'} ${isGreeks ? " min-w-[70px]" : " "}`}
            >
                <span className="font-semibold text-p300">
                    {label} {value}
                </span>
                <ChevronDown size={10} className="ml-1" />
            </button>
            {isOpen && (
                <div className="absolute z-[99999] mt-1 w-full border border-n200 bg-p400 rounded shadow-sm max-h-[150px] overflow-y-auto no-scrollbar">
                    {options.map((option, idx) => (
                        <div
                            key={idx}
                            className={`px-2 py-1 hover:bg-n100 cursor-pointer text-p300 shadow-sm ${option === value ? 'bg-n100' : 'hover:bg-gray-100'
                                }`}
                            onClick={() => {
                                onChange(option);
                                setIsOpen(false);
                            }}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
